import React, { useState, useEffect } from 'react';
import { CustomInput } from 'reactstrap';
import './switch.scss';

export function Switch({ id, active, status, type, row, extractTime }) {

  const [isActive, setIsActive] = useState(active);

  useEffect(() => {
    setIsActive(active);
  }, [active])

  const switchChange = () => {
    setIsActive(!isActive);
    if (status) status({
      enable: !isActive,
      id: id
    });

    if (extractTime) {
      extractTime(
        {
          time: !isActive,
          identifier: type,
          key: row
        }
      );
    }
  }

  return (
    <CustomInput type="switch" id={id} onChange={switchChange} checked={isActive} />
  );
}
